<template>
  <v-row class="home-index px-sm-16 d-flex align-center mx-auto">
    <v-row>
      <v-col cols="12" sm="6" v-for="(item, i) in mainlists" :key="i" class="pa-sm-0">
        <v-hover v-slot:default="{ hover }">
          <v-card :elevation="hover ? 20 : 10"
            :class="'cycbg'+(i+1) + (!$vuetify.breakpoint.xsOnly?' pa-16 cyc'+(i+1):'')" router :to="item.href">
            <v-card-title :class="hover ? 'text-h5':''" primary-title>
              <v-icon :size="hover?32:''" class="mr-2">{{ item.icon }}</v-icon>{{ item.title }}
            </v-card-title>
            <v-list-item three-line>
              <v-card-text class="grey--text">{{ item.text }}</v-card-text>
            </v-list-item>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-row>
</template>
<script>
  export default {
    name: "Index",
    data: function () {
      return {
        mainlists: [{
          title: "批次管理",
          href: "/pici",
          icon: 'mdi-animation',
          text: '添加和管理产品批次，为合格证打印做准备',
        },
        {
          title: "合格证",
          href: "/hgz",
          icon: 'mdi-qrcode',
          text: '打印和管理已打印的合格证',
        },
        {
          title: "农事日志",
          href: "/jilu",
          icon: 'mdi-sprout',
          text: '[可选操作]添加和管理农事操作日志，为合格证扫码溯源服务',
        },
        {
          title: "评价信息",
          href: "/rating",
          icon: 'mdi-thumb-up',
          text: '查看消费者对产品的评价信息',
        },
        ],
      };
    },
  };
</script>
<style scoped>
  .home-index {
    max-width: 1000px;
    min-height: 100vh;
    margin-top: -100px;
    padding-top: 100px;
  }

  .home-index .cycbg1 {
    background: #E0F7FA;
  }

  .home-index .cycbg2 {
    background: #F1F8E9;
  }

  .home-index .cycbg3 {
    background: #F9FBE7;
  }

  .home-index .cycbg4 {
    background: #E1F5FE;
  }

  .home-index .cyc1 {
    border-radius: 0 50% 0 50%;
  }

  .home-index .cyc2 {
    border-radius: 50% 0 50% 0;
  }

  .home-index .cyc3 {
    border-radius: 50% 0 50% 0;
  }

  .home-index .cyc4 {
    border-radius: 0 50% 0 50%;
  }
</style>